var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{class:_vm.preCls + 'content-box',staticStyle:{"background":"rgb(242, 242, 246)"}},[_c('div',{staticClass:"header"},[_c('header-left',{staticClass:"header-left"}),_c('header-right',{staticClass:"header-right"})],1),_c('EcMain',{staticClass:"EcMain"}),_c('EcFooter',{staticClass:"EcFooter"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }